import React from 'react';
import ClockIcon from '@atlaskit/icon/core/clock';
import DateTimeField from '@atlassian/jira-issue-create-commons/src/ui/date-time-field/index.tsx';
import { DATETIME_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DateTimeFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { dateTimeFieldWriter } from '../writers/index.tsx';

const DateTimeCustomFieldTypeComponent = (props: ProvidedFieldProps) => (
	<DateTimeField {...props} />
);

export const DateTimeCustomFieldTypeConfig: FieldTypeConfig<string> = {
	icon: ClockIcon,
	type: DATETIME_CF_TYPE,
	Component: DateTimeCustomFieldTypeComponent,
	placeholder: <DateTimeFieldPlaceholder />,
	writer: dateTimeFieldWriter,
};
